const dbName = 'videebopDb'
const dbVersion = 4

const openAndrunTransaction = (options)=>{
  let db
  const openRequest = indexedDB.open(dbName, dbVersion);
  openRequest.onupgradeneeded = function (e) {
    db = e.target.result
    console.log('running onupgradeneeded')
    if (!db.objectStoreNames.contains("files")){
      db.createObjectStore("files")
    }
  }
  openRequest.onsuccess = function (e) {
    console.log('Success opening database')
    db = e.target.result
    const tx = db.transaction("files", "readwrite")
    const store = tx.objectStore("files")
    options.onReady(store)
  }
  openRequest.onerror = function (e) {
    console.error('Error opening database')
  }
}

const saveFileLocally = (key, file) => {
  openAndrunTransaction({
    onReady: (store) => {
      let req = store.put(file, key)
      req.onerror = function(e) {
        console.error("Error saving file", e)
      };
      req.onsuccess = function(event) {
        console.log(`Successfully saved file with key ${key}.`)
      };
    }
  })
}

const loadFileLocally = (key) => {
  openAndrunTransaction({
    onReady: (store) => {
      let req = store.get(key)

      req.onerror = function(e) {
        console.error("Error loading file:", e)
      }

      req.onsuccess = function(event) {
        console.log('Successfully retrieved file.', req.result)

        if (req.result) {
          const storedBlob = req.result
          console.log('Blob retrieved from indexedDb:', storedBlob);
          event = new CustomEvent('fileLoadedLocally', { detail: { key, blob: storedBlob } })
          window.dispatchEvent(event)
        }
      }
    }
  })
}

const deleteFileLocally = (key) => {
  openAndrunTransaction({
    onReady: (store)=>{
      let req = store.delete(key)
      req.onerror = function(e) {
        console.error(`Error deleting file ${key}:`, e)
      };
      req.onsuccess = function(event) {
        console.log(`Successfully deleted file ${key}`)
      };
    }
  }) 
}

export {
  saveFileLocally,
  loadFileLocally,
  deleteFileLocally,
}
